import React, { FunctionComponent } from 'react';
import { Lead } from '../../../../services/dtos/lead';
import CreateLead from '../../../containers/create-lead/CreateLead';
import * as styles from './CreateLeadSection.style';

export interface CreateLeadSectionProps {
  title: string,
  source?: string,
  campaign?: string,
  dataRef: string,
  dataTracking: string,
  onSuccess: (lead: Lead) => void,
}

const CreateLeadSection: FunctionComponent<CreateLeadSectionProps> = ({
  title,
  ...rest
}) => (
  <div css={styles.formBox}>
    <div css={styles.formWrapper}>
      <div css={styles.formTitle}>{title}</div>
      <CreateLead {...rest} />
    </div>
  </div>
);

export default CreateLeadSection;
